import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import * as L from 'leaflet';
import { Partner } from 'src/app/core/partners/models/partners.model';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit, AfterViewInit {
  @Input() fromLocation: { lat: number; lon: number };
  @Input() toLocation: { lat: number; lon: number };
  @Input() routeCoordinates: L.LatLngExpression[];
  @Input () partner : Partner;

  private map: L.Map;

  ngOnInit(): void {
    console.log('partner:', this.partner);
    console.log('fromLocation:', this.fromLocation);
    console.log('toLocation:', this.toLocation);
    console.log('routeCoordinates:', this.routeCoordinates);
  }

  ngAfterViewInit(): void {
    this.initMap();
    this.renderMarkersAndRoute();
  }

  private initMap(): void {
    this.map = L.map('map', {
      center: [this.fromLocation.lat, this.fromLocation.lon],
      zoom: 13
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    tiles.addTo(this.map);
  }

  private renderMarkersAndRoute(): void {
    // Añadir marcador de origen
    const originTooltip = this.partner?.name || 'Origen';
    L.circleMarker([this.fromLocation.lat, this.fromLocation.lon], {
      color: '#3880ff',
      radius: 8,
      fillOpacity: 1
    })
      .addTo(this.map)
      .bindTooltip(originTooltip, { permanent: true, direction: 'top' });

    // Añadir marcador de destino
    L.circleMarker([this.toLocation.lat, this.toLocation.lon], {
      color: '#ff0000',
      radius: 8,
      fillOpacity: 1
    })
      .addTo(this.map)
      .bindTooltip('Destino', { permanent: true, direction: 'top' });

    // Añadir línea de la ruta
    if (this.routeCoordinates && this.routeCoordinates.length > 0) {
      const routeLine = L.polyline(this.routeCoordinates, {
        color: 'blue',
        weight: 3,
        opacity: 0.7
      }).addTo(this.map);

      // Ajustar la vista del mapa para incluir toda la ruta
      this.map.fitBounds(routeLine.getBounds());
    }
  }
}